import axios from "axios";
import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
let secretKey = import.meta.env.VITE_SECRET_KEY;
const user_key = import.meta.env.VITE_AUTH_KEY;
let Urls = import.meta.env.VITE_APIURL;

export const API = {
  getMethod,
  CreateMethod,
  DeleteMethod,
  UpdateMethod,
  getToken,
  ShowMessega,
  OPTMethod,
};

let EndPoint = {
  validate_login_id: "validate_login_id",
  "calculate-premium": "calculate-premium",
  "check-eligible-sa": "check-eligible-sa",
  "check-lifestyle-eligibility": "check-lifestyle-eligibility",
  "check-family-history-eligibility": "check-family-history-eligibility",
  "cancer_care_logo": "cancer_care_logo",
  "cancer_care_hero": "cancer_care_hero",
  "cancer_care_disclaimer": "cancer_care_disclaimer",

  add_comment:"add_comment",
  react_to_post:"react_to_post",
  get_post_reaction:"get_post_reaction",
  track_cancer_video_click:"track_cancer_video_click",
  get_comments:"get_comments"
};

function ShowMessega(response, go_route = false) {
  if (response?.status == 201 || response?.status == 200) {
    toast.success(decode_response(response).message, {
      autoClose: 2000,
    });
    if (go_route != false) {
      window.location.href = go_route;
    }
  } else if (response?.status == 1) {
    toast.success(response.message, {
      autoClose: 2000,
    });
  } else if (response?.status == 2) {
    toast.error(response?.message, {
      autoClose: 2000,
    });
  } else if (response?.status == 429) {
    toast.error(response?.data, {
      autoClose: 3000,
    });
  } else if (response?.status == 401) {
    toast.error(response?.data, {
      autoClose: 3000,
    });
  } else {
    toast.error(response?.data?.message, {
      autoClose: 2000,
    });
  }
}
function decodedPlaload(text) {
  if (text) {
    const cleanedText = text.replace(/&news_id=[^&]+/g, "");
    const bytes = CryptoJS.AES.decrypt(cleanedText, secretKey);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    const parse = JSON.parse(originalText);
    return parse;
  } else {
    return null;
  }
}

const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
};

function getToken() {
  if (!localStorage.getItem("deviceId")) {
    localStorage.setItem("deviceId", uuid(16));
  }
  if (localStorage.getItem(user_key) != null) {
    let usr = localStorage.getItem(user_key);
    let user = decodedPlaload(usr);
    let auth = user;
    return {
      headers: {
        Authorization: `Bearer ` + auth.token,
        "x-device-id": localStorage.getItem("deviceId") || "",
      },
    };
  } else {
    return {
      headers: {
        "x-device-id": localStorage.getItem("deviceId") || "",
      },
    };
  }
}

function getMethod(key, pay_id) {
  return axios
    .get(Urls + EndPoint[key] + (pay_id || ""), getToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err?.response?.status == 401) {
        // 
        toast.error(err.response.data.message, {
          autoClose: 3000,
        });
        setTimeout(() => {
          
          window.location.href = "/login";
        }, 2000);
        return false;
      } else {
        return err.response;
      }
    });
}

function CreateMethod(key, data, content = "", params = "") {
  return axios
    .post(Urls + EndPoint[key] + params, data, getToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err?.response?.status == 401) {
        
        toast.error(err.response.data.message, {
          autoClose: 3000,
        });
        // setTimeout(() => {
        //   
        //   window.location.href = "/login";
        // }, 2000);
        return false;
      } else if (err?.response?.status == 429) {
      } else {
        return err.response;
      }
    });
}

function OPTMethod(key, data, content = "", params = "") {
  return axios
    .options(Urls + EndPoint[key] + params, data, getToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err?.response?.status == 401) {
        
        toast.error(err.response.data.message, {
          autoClose: 3000,
        });
        setTimeout(() => {
          
          window.location.href = "/login";
        }, 2000);
        return false;
      } else if (err?.response?.status == 429) {
      } else {
        return err.response;
      }
    });
}

function DeleteMethod(key, pay_id) {
  return axios
    .delete(Urls + EndPoint[key] + pay_id, getToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      return err.response;
    });
}

function UpdateMethod(key, pay_id, payload = {}, content = "", content2 = false) {
  return axios
    .patch(Urls + EndPoint[key] + pay_id, payload, getToken())
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err?.response?.status == 401) {
        
        toast.error(err.response.data.message, {
          autoClose: 3000,
        });
        setTimeout(() => {
          
          window.location.href = "/login";
        }, 2000);
        return null;
      } else {
        return err.response;
      }
    });
}
